import Collection   from 'ol/Collection'
import { toContext } from 'ol/render'
import Feature      from 'ol/Feature'
import Fill         from 'ol/style/Fill'
import Icon         from 'ol/style/Icon'
import Point        from 'ol/geom/Point'
import Polygon      from 'ol/geom/Polygon'
import Stroke       from 'ol/style/Stroke'
import Style        from 'ol/style/Style'
//import Text         from 'ol/style/Text'
import VectorLayer  from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'

//import blueMarker   from '../resources/images/marker-blue.png'
//import greenMarker  from '../resources/images/marker-green.png'
//import redMarker    from '../resources/images/marker-red.png'
//import yellowMarker from '../resources/images/marker-yellow.png'

const getMarker = (id, coordinate, label, color) => {
  let feature = new Feature({
        geometry: new Point(coordinate),
        myLabel: label,
        //xOffset: 50,  // could be used to adjust for # of digits in label
        myId: 'markerId'
      });
  feature.setId(id);
  //feature.setStyle(getMarkerStyleFunction(color));
  feature.setStyle(getCrosshairStyle([0,0,0,1]));
  //feature.setStyle(getMarkerStyleFunction(color));
  return feature;
}

const getCrosshairStyle = (color) => {
    const symbol = [
      [6,0], [6,4], [6,2], [7,2], [8,3], [9,3], [9,4], [10,5], [10,6], [12,6], [8,6], [10,6], [10,7],
      [9,8], [9,9], [8,9], [7,10], [6,10], [6,12], [6,8], [6,10], [5,10], [4,9], [3,9], [3,8], [2,7],
      [2,6], [4,6], [0,6], [2,6], [2,5], [3,4], [3,3], [4,3], [5,2], [6,2], [6,0]
    ];
    const symbolBoxSize = 12;
    const scale = 1.5;
    const size = symbolBoxSize * scale;

    const scaleFunction = (coordinate) => {
      return [coordinate[0] * scale, coordinate[1] * scale];
    };

    const canvas = document.createElement('canvas');
    const vectorContext = toContext(
      (canvas.getContext('2d')),
      { size: [size, size], pixelRatio: 1 }
    );
    vectorContext.setStyle( new Style({
      fill: new Fill({ color: 'rgba(255, 153, 0, 0.0)'}),
      stroke: new Stroke({color: color, width: 1.0})
    }));

    vectorContext.drawGeometry(new Polygon([symbol.map(scaleFunction)]));

    const style = new Style({
        image: new Icon({
            img: canvas,
            imgSize: [size, size],
            rotation: 0.0
        })
    });

    return style;
}

/*
const getMarkerStyleFunction = (color) => {
  const iconSrc = {
    BLUE:   blueMarker,
    GREEN:  greenMarker,
    RED:    redMarker,
    YELLOW: yellowMarker,
  };

  return (feature, resolution) => {
    return new Style({
      image: new Icon ({
        src: iconSrc[color],
        anchor: [0.5, 1.0],
        scale: 0.10
        //imgSize:[20, 30]
      }),
      text: new Text ({
        text: feature.get('myLabel'),
        offsetY: -19,
        //font: '12px helvetica, sans-serif',
        font: 'bold 12px arial, sans-serif',
        fill: new Fill({
          color: 'white'
        })
  //      ,stroke: new Stroke({
  //        color:  'red',
  //        width: 1
  //      })
      })
    });
  }
}
*/

class Markers {
  constructor(layerName, projection='EPSG:2264') {
    this.layerName = layerName;

    this.layer = new VectorLayer({
      layerName: this.layerName,
      visible: true,
      //style: markerFeatureStyleFunction,
      source: new VectorSource({
          features: new Collection(),
          projection: projection
      })
    });
    this.layer.printLayer = true;

    this.BLUE =   'BLUE';
    this.GREEN =  'GREEN';
    this.RED =    'RED';
    this.YELLOW = 'YELLOW';

  }

  add(id, coordinate, label, color=this.BLUE) {
    const marker = getMarker(id, coordinate, label, color);
    //console.log(marker);
    //console.log(this.layer.getSource);
    this.layer.getSource().addFeature(marker);
    return marker;
  }

  clear() {
    this.layer.getSource().clear();
  }

  remove(marker) {
    this.layer.getSource().removeFeature(marker);
  }

  removeById(id) {
    const source = this.layer.getSource();
    const marker = source.getFeatureById(id);
    source.removeFeature(marker);
  }
}

export default Markers;
